import React from "react";
import { AdminIntro } from "./adminIntro";
// ----------------------
export const AdminPage = () => {
  return (
    <div>
      <AdminIntro />

     
    </div>
  );
};
